import CounterInput from "./CounterInput";
export default CounterInput;
